import React from "react";
import { STAR_RATING_STAR_CLASS_NAME } from "tsi-common-react/src/utils/starRating";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./OrientTestimonials.module.scss";

/**
 * Native port of ``cms/blocks/hc-block/hc-block--orient-testimonials.html``.
 *
 * Five identical inline star ``<svg>``s followed by the heading + testimonial
 * articles. The star markup (class, dimensions, viewBox, path) is transcribed
 * verbatim from the legacy partial.
 */
const Star = (): React.JSX.Element => (
    <svg
        className={concatClassNames([
            STAR_RATING_STAR_CLASS_NAME,
            "configurator__star",
        ])}
        width="50px"
        height="50px"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path d="M20.388,10.918L32,12.118l-8.735,7.749L25.914,31.4l-9.893-6.088L6.127,31.4l2.695-11.533L0,12.118            l11.547-1.2L16.026,0.6L20.388,10.918z"></path>
    </svg>
);

export const OrientTestimonials = (): React.JSX.Element => (
    <>
        <h6>WHY CHOOSE TEMPUR-PEDIC?</h6>

        <div>
            <Star />
            <Star />
            <Star />
            <Star />
            <Star />
        </div>

        <h3>10,000+ Five-Star Mattress Reviews</h3>

        <div className={styles.testimonials}>
            <article>
                <p>
                    “So happy we chose a Tempur-Pedic. From ordering, to
                    delivery to comfort, our experience has been outstanding.”
                </p>
                <p>
                    {"— "}
                    <em>Sleeping</em> in Wisconsin
                </p>
            </article>
            <article>
                <p>
                    “Best bed we ever had. Delivery and setup were super even
                    with COVID. It has changed our sleeping habits for the
                    best.”
                </p>
                <p>
                    {"— "}
                    <em>Hoyts</em> in Vermont
                </p>
            </article>
            <article>
                <p>
                    “I LOVE my bed! It’s the second mattress we bought and it
                    should’ve been the first. I can’t imagine sleeping on
                    anything else!”
                </p>
                <p>
                    {"— "}
                    <em>Fool No More</em> in New Jersey
                </p>
            </article>
        </div>
    </>
);
